import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchAllPositionCandidates } from './fetchAllPositionCandidates';

export function deleteCandidate(positionId, candidateId) {
  return (dispatch) => {
    return axios
      .delete(`/position/candidate/${candidateId}`)
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          Swal.fire({
            title: 'Success',
            text: 'Successfully deleted a candidate',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          });
          dispatch(fetchAllPositionCandidates(positionId));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
